import { Log, Rect, Size } from ".././MyHelpers";
import {  } from "../version";
import { Resource } from "./Resource";
export class ImageResource extends Resource
{
	//private parent: HTMLElement = null;
	//private cssElem: HTMLElement = null;
	public get Name(): string {
		return this.name;
	}
	public get Type(): string {
		return "img"
	}

	public get LogName(): string {
		return "ImageResource-" + this.name;
	}

	public img: HTMLImageElement = null;
	//public decoded: boolean = false;

	public constructor(path: string, name: string = null, required: boolean = true) {
		super(path, name, required)
	}


	public Load(preventCache: boolean = false): void {

		Log.Debug(this.LogName, `Load, preventCache: ${preventCache}\n${new Error().stack}`);

		this.img = new Image();
        this.img.crossOrigin = "anonymous";

		let callIndex = 0;
		this.img.onload = () => 
		{
			Log.Debug(this.LogName, `Loaded ${callIndex}\n${new Error().stack}`); 
			callIndex++;
			this.Loaded();
		}
	    this.img.onerror = () => {
			Log.Debug(this.LogName, `LoadError`);
			this.LoadError();
		}

	    // set path last, loads by itself
	    this.img.src = this.path;
	}

	public override Reload(preventCache: boolean = false):  void {
		super.Reload(preventCache);
		Log.Debug(this.LogName, `Reload, preventCache: ${preventCache}`);
		this.Load(preventCache);
	}

	CssBackground(): string {
		return "url(" + this.path + ")";
	}

	Inline(elementClass:string):string
	{
		return '<span class="'+elementClass+'" style="background-image:url('+this.path+')"></span>';
	}
}

export class DecodedImageResource extends Resource
{
	public override get Name(): string {
		return this.name;
	}
	public override get Type(): string {
		return "img"
	}

	public get LogName(): string {
		return "DecodedImageResource-" + this.name;
	}

	public img: HTMLImageElement = null;
	//public decoded: boolean = false;

	protected decodedSize: Size;
	protected decodedRect: Rect;
	protected decodedImage: ImageBitmap | HTMLCanvasElement;

	public constructor(path: string, name: string = null, decodedSize: Size = null) {
		super(path, name, true)

		this.decodedSize = this.decodedSize;
	}

	public Load(preventCache: boolean = false): void {

		let callIndex = 0;
		const finalize = (decodedImage: ImageBitmap | HTMLCanvasElement) => {
			Log.Debug(this.LogName, `Decoded image ${callIndex}\n${new Error().stack}`);
			callIndex++;
			this.decodedImage = decodedImage as any; // type fudge if needed
			this.Loaded();
		};
	
		const fail = () => {
			Log.Error(this.LogName, `Decoding failed (onload) ${new Error().stack}`);
			this.LoadError();
		};
	
		
		this.img = new Image();
        this.img.crossOrigin = "anonymous";
		this.img.onload = () => 
		{
			let options: any = {};
			if (this.decodedSize)
			{
				this.decodedRect = new Rect(0, 0, this.decodedSize.Width, this.decodedSize.Height);
				options = {
					resizeWidth: this.decodedSize.Width,
					resizeHeight: this.decodedSize.Height
				};
			}
			else
			{
				this.decodedSize = new Size(this.img.width, this.img.height);
				this.decodedRect = new Rect(0, 0, this.img.width, this.img.height);
			}
		
			if ("createImageBitmap" in globalThis) {
				// try ImageBitmap path
				createImageBitmap(this.img, 0, 0, this.img.width, this.img.height)
					.then(finalize)
					.catch(reason => {
						Log.Error(this.LogName, "CreateImageBitmap failed, falling back to canvas", reason);
						this.fallbackCanvasDecode(this.img, finalize, fail);
					});
			} else {
				this.fallbackCanvasDecode(this.img, finalize, fail);
			}
		}
	    this.img.onerror = () => {
			Log.Debug(this.LogName, "Decoding failed (onerror)");
			this.LoadError();
		};

	    // set path last, loads by itself
	    this.img.src = this.path ;
	}

	private fallbackCanvasDecode(image: HTMLImageElement, resolve: (canvas: HTMLCanvasElement) => void, reject: () => void): void {
		try {
			const canvas = document.createElement("canvas");
			canvas.width = image.width;
			canvas.height = image.height;
			const ctx = canvas.getContext("2d");
			if (!ctx)
			{
				Log.Error(this.LogName, `FallbackCanvasDecode error: No context`);
				return reject();
			}
			ctx.drawImage(image, 0, 0);
			resolve(canvas);
		} catch (e) {
			Log.Error(this.LogName, `FallbackCanvasDecode error: ${e}`);
			reject();
		}
	}

	public DecodedImage(): ImageBitmap | HTMLCanvasElement
	{
		return this.decodedImage;
	}

	public DecodedSize(): Size
	{
		return this.decodedSize;
	}

	public DecodedRect(): Rect
	{
		return this.decodedRect;
	}

	CssBackground(): string {
		return "url(" + this.path + ")";
	}

	Inline(elementClass:string):string
	{
		return '<span class="'+elementClass+'" style="background-image:url('+this.path+')"></span>';
	}
}
